<template>
  <header>
    <div class="main-content">
      <router-link :to="{name:'Home', query:{skin: 'pvm', lang}}" class="logo" v-if="skin==='pvm'" replace>
        <h1 class="logo-title">
          {{ $t('pvmTitle:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/GLPR_PVM2.svg" class="logo-img">
        <img alt="logo" src="@/assets/images/logo_pvm_fixed.png" class="logo-fixed-img">
        </h1>
      </router-link>
      <router-link :to="{name:'Home', query:{skin: 'tkl', lang}}" class="logo" v-else-if="skin==='tkl'">
        <h1 class="logo-title">
          {{ $t('tklTitle:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/GLPR_TKL_Trad2.svg" class="logo-img">
          <img alt="logo" src="@/assets/images/K-head_black_RGB.png" class="logo-fixed-img tkl-log">
        </h1>
      </router-link>
      <router-link :to="{name:'Home', query:{skin: 'gl', lang}}" class="logo" v-else-if="skin==='gl'">
        <h1 class="logo-title">
          {{ $t('glTitle:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/hotel/gl-logo.png" class="logo-img">
          <img alt="logo" src="@/assets/images/hotel/gl-logo-mob.png" class="logo-fixed-img gl-log">
        </h1>
      </router-link>
      <router-link :to="{name:'Home', query:{skin: 'glp', lang}}" class="logo" v-else>
        <h1 class="logo-title">
          {{ $t('title:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/logo.png" class="logo-img">
          <img alt="logo" src="@/assets/images/logo_fixed.png" class="logo-fixed-img">
        </h1>
      </router-link>
      <header-switch/>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src
import HeaderSwitch from '@/components/layout/HeaderSwitch.vue'

export default {
  components: {
    HeaderSwitch
  },
  computed: {
    skin() {
      return this.$store.state.gaData.skinCode
    },
    lang() {
      return this.$i18n.locale
    },
  }
}
</script>
